import React, { useState } from "react";
import { RouteComponentProps } from "@reach/router";
import { Grid, TextField, Box, CircularProgress } from "@material-ui/core";

interface ITestLogin extends RouteComponentProps {}

const TestLogin = (props: ITestLogin) => {
	const [loading, setLoading] = useState(false);
	const [ssn, setSsn] = useState("");

	const autoFocusInputRef = (input: any) => {
		if (input)
			setTimeout(() => {
				input.focus();
			}, 100);
	};

	const handleChange = (newValue: string) => {
		setSsn(newValue);

		if (newValue.length === 11) {
			setLoading(true);
			return fetch(`/api/login/testlogin/${newValue}`, { method: "POST" }).then(
				async (res) => {
					if (res.status === 200) {
						window.location.href = "/";
					}
				}
			);
		}
	};

	return (
		<Grid
			container
			spacing={2}
			direction="column"
			alignItems="center"
			justify="center"
		>
			<Grid item>
				<TextField
					autoFocus
					inputProps={{ maxLength: 11 }}
					placeholder="Skriv inn personnummer"
					value={ssn}
					label="Persnonnummer"
					onChange={(e) => handleChange(e.target.value)}
					inputRef={autoFocusInputRef}
				/>
			</Grid>

			{loading && (
				<Grid item>
					<Box display="flex" justifyContent="center">
						<CircularProgress size={64} />
					</Box>
				</Grid>
			)}
		</Grid>
	);
};

export default TestLogin;
